module.exports = __webpack_public_path__ + "img/rings.86dce071.svg";